$(document).ready(function () {
  const gridMode = localStorage.getItem("gridMode");
  if (gridMode === "change-2col") {
    $(".grid-display").addClass("change-2col");
  }

  $(document).on('click', '.change-grid', function () {
    $(".grid-display").toggleClass("change-2col");

    if ($(".grid-display").hasClass("change-2col")) {
      localStorage.setItem("gridMode", "change-2col");
    } else {
      localStorage.removeItem("gridMode");
    }
  });

  // 追加グロナビ
  $('.have-child').on('click', function () {
    let $this = $(this);
    let activeHaveChild = $('.have-child.active');
    let childList = $this.find('.child-list');

    $this.toggleClass('active');

    if (activeHaveChild && activeHaveChild[0] !== $this[0]) {
      activeHaveChild.removeClass('active');
    }

    $('.have-child').not($this).find('.child-list').removeClass('active');

    childList.toggleClass('active');
  });
});
